module.exports = __webpack_public_path__ + "static/img/product-7.fafbe59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/product-7.png
// module id = LZ6U
// module chunks = 0